import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

/**
 * Stat counts use the default dark text color instead of semantic success/warning colors to meet
 * WCAG AA contrast requirements at this font size. Semantic meaning is preserved through label
 * text ("skipped", "merge fails") and the "with warnings" indicator.
 */
export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		background: THEME.colors.background.dark,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.text.main,
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: THEME.typography.fontSizes.xs,
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.sm,
		padding: `6px ${THEME.spacing.sm}px`,
	},
	label: {
		color: THEME.colors.text.main,
		fontWeight: THEME.typography.fontWeights.bold,
		letterSpacing: 0.5,
		textTransform: 'uppercase',
	},
	stat: {
		whiteSpace: 'nowrap',
	},
	statCount: {
		fontWeight: THEME.typography.fontWeights.bold,
	},
	warningIndicator: {
		color: THEME.colors.danger.main,
		alignItems: 'center',
		display: 'inline-flex',
		fontWeight: THEME.typography.fontWeights.bold,
		gap: THEME.spacing.xs,
	},
	warningIcon: {
		height: 12,
		width: 14,
	},
	detailsButton: {
		height: 'auto',
		fontSize: THEME.typography.fontSizes.xs,
		padding: 0,
	},
});
